import { render, staticRenderFns } from "./EmailsHistory.vue?vue&type=template&id=a3458ae6&"
import script from "./EmailsHistory.vue?vue&type=script&lang=js&"
export * from "./EmailsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports